/* global localData */
if (document.querySelector('.show-more-news')) {
  const renderedNews = document.querySelectorAll('.listing-block').length;
  const btnShowMore = document.querySelector('.show-more-news');
  const ajaxLoader = document.querySelector('.ajax-overlay');
  btnShowMore.setAttribute('data-showing', renderedNews.toString());
  btnShowMore.addEventListener('click', (e) => {
    e.preventDefault();
    ajaxLoader.removeAttribute('style');
    const xhr = new XMLHttpRequest();
    xhr.open('POST', localData.siteURL);
    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
    xhr.onload = function () {
      if (xhr.status === 200) {
        let html = '';
        const response = JSON.parse(xhr.responseText).data;
        response.news.forEach((element, index) => {
          let firstRowClasses = '';
          let secondRowClasses = '';
          if (index === 0) {
            secondRowClasses = ' : listing-block--small : has-bg';
          } else if (index === 1) {
            firstRowClasses = ' : text-right';
          } else if (index === 3) {
            firstRowClasses = ' : text-right';
            secondRowClasses = ' : listing-block--small';
          }
          html += `<div class="col-sm-6 : col-xs-12${firstRowClasses}">
                        <article class="listing-block${secondRowClasses}">
                          <a href="${element.url}">
                            <figure class="listing-block__image">
                        <div class="image-aspect : image-aspect--16-9">
                            <div class="image-aspect__bg" data-responsive="responsive-bg-image" style="background-image: url(${element.imageUrl});">
                                <img class="responsive-bg-img" src="${element.imageUrl}" alt="${element.imageAlt}">
                            </div>
                        </div>
                            </figure>
                            <div class="listing-block__content : text--uppercase">
                              <div class="listing-block__date : text--12 : text--grey">
                                <p>${element.date}</p>
                              </div>
                              <header class="listing-block__header">
                        <div class="title : title--h4">
                            <h4>${element.title}</h4>
                          </div>
                              </header>
                              <div class="arrow : arrow--red : arrow--large : arrow--right">
                              <i class="icon : icon-arrow-right : icon-arrow-red : arrow--large"></i>
                            </div>
                            </div>
                          </a>
                        </article>
                      </div>`;
        });
        const showing = Number(btnShowMore.getAttribute('data-showing')) + Number(response.news.length);
        btnShowMore.setAttribute('data-showing', showing.toString());
        document.getElementById('news-block').innerHTML += html;
        if (Number(response.allNews) === Number(showing)) {
          btnShowMore.style.display = 'none';
        }
        ajaxLoader.style.display = 'none';
      }
    };
    xhr.send(`action=showMoreNews&lang=${localData.lang}&offset=${btnShowMore.getAttribute('data-showing')}&nonce=${localData.nonce}`);
  });
}
